var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.756,
    height: 23.348,
    viewBox: "0 0 22.756 23.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-solid",
    d: "M9.927,39.174l1.157-1.157a1.245,1.245,0,0,1,1.767,0l10.13,10.125a1.245,1.245,0,0,1,0,1.767L12.85,60.039a1.245,1.245,0,0,1-1.767,0L9.927,58.882a1.252,1.252,0,0,1,.021-1.787l6.279-5.982H1.251A1.248,1.248,0,0,1,0,49.862V48.194a1.248,1.248,0,0,1,1.251-1.251H16.227L9.948,40.962a1.243,1.243,0,0,1-.021-1.787Z",
    transform: "translate(60.406) rotate(90)",
    fill: "#3ca7d6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPrimary);
export default __webpack_public_path__ + "static/media/arrow-down-primary.38f377afb01cd571c70f6ceeb8b2bf59.svg";
export { ForwardRef as ReactComponent };